export default __webpack_public_path__ + "static/media/sidebar_expand.dc4369d8.svg";